import { SimpleAggregation } from '@core/Entities/Search/Aggregations/Aggregations.entity';

const getOptionsWithAggs = (
  filterOptions: Record<string, any>,
  aggregations: SimpleAggregation,
) => {
  const result: any[] = [];

  Object.keys(filterOptions).forEach(key => {
    const filter = filterOptions[key];
    const filterAggregationKeys = Array.isArray(filter.id) ? filter.id : [filter.id];

    const totalCount = filterAggregationKeys.reduce(
      (total: number, aggKey: string | number) => total + (aggregations[aggKey] || 0),
      0,
    );

    if (totalCount > 0) {
      result.push({
        ...filter,
        id: filterAggregationKeys.length > 1 ? filterAggregationKeys : filterAggregationKeys[0],
        count: totalCount,
      });
    }
  });

  return result;
};

export { getOptionsWithAggs };
